import gql from "graphql-tag"

/** Vorbelegung beim Setzen des Hakens: letzte Buchung des Teilnehmers mit Rechnungsadresse, sonst Teilnehmer, sonst Bucher. */
export const GET_BILLING_ADDRESS_SUGGESTION = gql`
    query BillingAddressSuggestionEndUserApp($attendeeId: ID!) {
        billingAddressSuggestionEndUserApp(attendeeId: $attendeeId) {
            billingCompanyName
            billingFirstname
            billingLastname
            billingAddition
            billingStreet
            billingPostCode
            billingCity
        }
    }
`
